var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 640,
    viewBox: "0 0 1920 640",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#f0f0f0",
    rx: 4,
    ry: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 1840,
    height: 560,
    rx: 16,
    ry: 16,
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f5f5f5;#fafafa;#f5f5f5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.2s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 700,
    height: 60,
    rx: 4,
    ry: 4,
    fill: "#d0d0d0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#d0d0d0;#a7a7a7;#d0d0d0",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.4s"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 160,
    width: 500,
    height: 30,
    rx: 4,
    ry: 4,
    fill: "#d0d0d0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#d0d0d0;#d8d8d8;#d0d0d0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 220,
    width: 800,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "#d8d8d8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#d8d8d8;#e0e0e0;#d8d8d8",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.6s"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 260,
    width: 750,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "#d8d8d8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#d8d8d8;#e0e0e0;#d8d8d8",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.7s"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 300,
    width: 700,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "#d8d8d8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#d8d8d8;#e0e0e0;#d8d8d8",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.8s"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 360,
    width: 200,
    height: 60,
    rx: 30,
    ry: 30,
    fill: "#d0d0d0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#d0d0d0;#c2c2c2;#d0d0d0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.9s"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 80,
    width: 820,
    height: 440,
    rx: 8,
    ry: 8,
    fill: "#e8e8e8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#e8e8e8;#d5d5d5;#e8e8e8",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.1d0b28c53ab760a04022d954792fae6b.svg";
export { ForwardRef as ReactComponent };